<template>
  <div class="dnno-footer-ad full">
    <div class="ukens-stilling">
      <div class="ukens-stilling-header">
        <h2 class="title">
          <a href="https://www.dnjobb.no/">DN Jobb</a>
        </h2>
        <h2 class="sub-title">
          {{ t('Position of the week') }}
        </h2>
      </div>
      <dn-live-wrapped-ad
        :id="id"
        class="wide-ad"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
const { t } = useI18n();
defineProps({
  id: {
    type: String,
    default: null,
    required: true
  }
});
</script>
<style scoped lang="scss">
.dnno-footer-ad {
  box-sizing: border-box;
  width: 100%;
  grid-column: span 12;
}

.ukens-stilling {
  background-color: var(--color-brand-utility-50);
  padding: var(--row-gap);

  .ukens-stilling-header {
    display: flex;
    align-items: flex-start;
    border-bottom: 1px solid var(--color-brand-utility-200);
    padding-bottom: var(--ui-gap);
    margin-bottom: var(--ui-gap);
  }

  .title {
    border-right: 1px solid var(--color-page-divider);
    font-size: 24px;
    line-height: 130%;
    font-weight: 500;
    padding-right: 16px;
    margin: 0;

    a {
      color: var(--color-brand-utility-700);
      text-decoration: none;
    }
  }

  .sub-title {
    font-size: 24px;
    font-weight: 500;
    padding-left: 16px;
    color: var(--color-brand-utility-700);
    margin: 0;
  }
}
</style>
